import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const requireConfirmationToCancelInsertion = createSelector(
  (state: RootState) => state.application.insertingObjectInfo?.type,
  (insertingObjectType) => {
    switch (insertingObjectType) {
      case 'componentDesign':
      case 'load':
      case 'parapetLoadSettings':
        return true;

      default:
        return false;
    }
  },
);
